import { coreLocalStorage } from '@/core/utils/localStorage';
import { getApiUrl } from '@/shared/helpers/environmentHelper';
import { useAuthStore } from '@/shared/modules/auth/business';
import { tokenIsExpired } from '@/shared/modules/auth/helpers';
import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { formatDate } from 'date-fns';
const baseQuery = fetchBaseQuery({
    baseUrl: `${getApiUrl()}/api/`,
    prepareHeaders: (headers) => {
        const token = coreLocalStorage.getItem('token');
        if (token)
            headers.set('authorization', `Bearer ${token}`);
        return headers;
    },
});
// From RTK Query official docs:
const baseQueryWithReauth = async (args, api, extraOptions) => {
    let result = await baseQuery(args, api, extraOptions);
    // Status 401 Unauthorized
    if (result.error && result.error.status === 401) {
        // try to get a new token
        const refreshResult = await baseQuery('/refreshToken', api, extraOptions);
        // TODO: to delete
        console.log('in baseQueryWithReauth, refreshResult:', refreshResult);
        // refresh result: {error: {status: 404, data: null}}
        if (refreshResult.data) {
            // store the new token
            //api.dispatch(authActions.tokenRefreshSuccess({ token: refreshResult.data as string }));
            //api.dispatch(authActions.authSuccess({ token: refreshResult.data as string }));
            // retry the initial query
            result = await baseQuery(args, api, extraOptions);
        }
        else {
            signOutIfRequired();
        }
    }
    return result;
};
/** Signs out only if not there is no token in storage or the token has expired. */
const signOutIfRequired = () => {
    // TODO: to delete later
    // const { token, user, signOut } = useAuthStore.getState();
    const { token, expiration, signOut } = useAuthStore.getState();
    // TODO: to delete
    console.log('in signOutIfRequired, expiration1:', expiration);
    console.log('in signOutIfRequired, expiration as date:', formatDate(new Date((expiration || 0) * 1000), 'PPpp'));
    console.log('in signOutIfRequired, now:', formatDate(Date.now(), 'PPpp'));
    console.log('in signOutIfRequired, isExpired:', tokenIsExpired(expiration));
    // if (!token || tokenIsExpired(user)) signOut();
    if (!token || tokenIsExpired(expiration))
        signOut();
};
export { baseQueryWithReauth as baseApiQuery };
